import { theme } from "@tm/utility/global";
import BirlaLogo from "../../icons/birlaLogo.png";
import FlightUpcomingImg from "../../icons/flightUpcoming.svg";
export const thankYouPageData = {
  title: "Your trip is successfully secured with TravelProtect",
  info: "Confirmation and order details are sent to <b>chhavi.singh@gmail.com</b> and <b>+91-78381-8903</b>",
  status: "pending",
  statusBg: FlightUpcomingImg.src,
  tagMessage: "PASSPORT DETAILS PENDING",
};

export const orderDetails = {
  planName: "TripMoney Tourer Plus Advanced Insurance",
  packName: "TATA AIG General Insurance",
  insPackName: "INSURANCE + ASSISTANCE (COMBO)",
  packColor: theme.purpleTxt,
  packImg: BirlaLogo.src,
  orderDetailAmt: [
    {
      orderDetail: "Total Amount",
      info: "₹ 25,155",
    },
    {
      orderDetail: "Order ID",
      info: "TM93567683990",
    },
    {
      orderDetail: "Sum Inusred",
      info: "Upto ₹ 1,00,000",
    },
    {
      orderDetail: "Travellers Inusred",
      info: "5  TRAvellers",
    },
    {
      orderDetail: "Destination Covered",
      info: "Thailand, Singapore",
    },
  ],
};

export const manageInsData = {
  title: "Manage Your Insurance<br/> & Get All The Help",
  info: "<b>Modify</b> your Insurance, <b>View Insurance Benefits</b>  and <b>Claim Insurance</b> and lot more, right from the app.",
  orderBtn: "GO TO YOUR ORDERS",
};

export interface persuasionDataProps {
  id: string;
  boldText?: string;
  normalText: string;
}

export const persuasionData: persuasionDataProps[] = [
  {
    id: "1",
    boldText: "RBI",
    normalText: "Authorized",
  },
  {
    id: "2",
    boldText: "Best Exchange Rates",
    normalText: "in the market",
  },
  {
    id: "3",
    boldText: "Transparent",
    normalText: "conversion rates",
  },
];

export const addPassportDetailData = {
  addPasstitle:
    "Please add your passport details <b>before Fri, 12 November 2022</b>  to generate policy document",
  addPassInfo:
    "Since your are travelling to an insurance mandatory country, Download the provisional policy from here.",
  addPassportCta: "DOWNLOAD PROVISIONAL POLICY",
  addPassportBtn: "ADD PASSPORT DETAILS",
};
